import { render, staticRenderFns } from "./franjas.vue?vue&type=template&id=e11aba4c&scoped=true"
import script from "./franjas.vue?vue&type=script&lang=js"
export * from "./franjas.vue?vue&type=script&lang=js"
import style0 from "./franjas.vue?vue&type=style&index=0&id=e11aba4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e11aba4c",
  null
  
)

export default component.exports